import axios from 'axios'

const counterURL = "https://optlm.visualon.info/api"

let counterApi = {}

function setAuthToken(token) {
    if (token) {
        counterApi = axios.create({
            baseURL: counterURL,
            headers: {
                Authorization: token
            }
        })
    } else {
        counterApi = axios.create({baseURL: counterURL})
    }
    counterApi.interceptors.response.use(
        response => response,
        error => {
          if (error.response && error.response.status === 401) {
            console.error("🚨 Intercepteur Axios : erreur 401 détectée !");
            return Promise.reject(error); // ❌ PAS de redirection immédiate
          }
          return Promise.reject(error);
        }
      );
      
}



setAuthToken(localStorage.getItem("jwtToken"))

export const updateUser = payload => counterApi.post(`/user/update`, payload)
export const getCurrentInfo = () => counterApi.get(`/user/me`)
export const updatePassword = payload => counterApi.post(`/password/update`, payload)
export const forgotPassword = payload => counterApi.post(`/password/forgot`, payload)
export const resetPassword = payload => counterApi.post(`/password/reset`, payload)

export const addCid = payload => counterApi.post(`/cid/add`,payload)
export const deleteCid = payload => counterApi.post(`/cid/delete`,payload)
export const requestCids = () => counterApi.get(`/cid`)
export const cleanUpAllowedCIDs = () => counterApi.get(`/cid/cleanup-cids`);

export const register = payload => counterApi.post(`/register`, payload)
export const login = payload => counterApi.post(`/login`, payload)

export const requestAccounts = () => counterApi.get(`/admin/accounts`)
export const addAccount = payload => counterApi.post(`/admin/accounts/new`, payload)
export const deleteAccount = payload => counterApi.post(`/admin/accounts/delete`, payload)

// Récupère les stats horaires pour un CID (session ou rung)
export const getChartById = (cid, kind, ts, flavor) =>
    counterApi.get(`/chart/${cid}?kind=${kind}${ts ? `&ts=${ts}` : ""}${flavor ? `&flavor=${flavor}` : ""}`);
  
  // Récupère le nombre total de sessions ou rungs
  export const getChartCount = (cid, kind, fts, tts) =>
    counterApi.get(`/chart/count?kind=${kind}${cid ? `&cid=${cid}` : ""}${fts ? `&fts=${fts}` : ""}${tts ? `&tts=${tts}` : ""}`);
  
  // Récupère la distribution de stats (plateforme, erreurs, etc.)
  export const getChartDistribution = (cid, kind, fts, tts, flavor) =>
    counterApi.get(`/chart/distribution?kind=${kind}${cid ? `&cid=${cid}` : ""}${fts ? `&fts=${fts}` : ""}${tts ? `&tts=${tts}` : ""}${flavor ? `&flavor=${flavor}` : ""}`);
  
  // Impression stats par OS (stat custom ?)
  export const getImpression = (cid, os) =>
    counterApi.get(`/${cid}/${os}`);
  
  // Récupère les stats 5min sur l'heure en cours
  export const getLastHourChartByCid = (cid, kind, flavor) =>
    counterApi.get(`/chart/last-hour?cid=${cid}&kind=${kind}${flavor ? `&flavor=${flavor}` : ""}`);
  export const getPacketVersionByCid = (cid) =>
    counterApi.get(`/user/version/${cid}`);

export const sendCustomerSupport = payload => counterApi.post(`/misc/support`, payload)

const apis = {
    setAuthToken,
    updateUser,
    updatePassword,
    forgotPassword,
    resetPassword,
    addCid,
    deleteCid,
    requestCids,
    register,
    login,
    getChartById,
    getChartCount,
    getChartDistribution,
    getCurrentInfo,
    getImpression,
    getLastHourChartByCid,
    requestAccounts,
    addAccount,
    deleteAccount,
    sendCustomerSupport,
    getPacketVersionByCid
}

export default apis
